import { render, staticRenderFns } from "./banner-web.vue?vue&type=template&id=4933a282"
import script from "./banner-web.vue?vue&type=script&lang=ts"
export * from "./banner-web.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports